import * as React from 'react';

import Typography from '@mui/material/Typography';


export const ErrorPage = () => {

  return (
    <>
      <Typography variant="h4">Ha ocurrido un problema</Typography>
    </>
  );
};